<template>
	<v-dialog v-model="show" style="max-width: 80%" @click:outside="onCancel">
		<v-card classx="p-0 xxx" style="width: 100%">
			<v-card-title class="d-flex justify-center">{{ confirm.title }}</v-card-title>
			<v-card-text v-if="confirm.message">
				{{ confirm.message }}
			</v-card-text>
			<v-card-actions class="d-flex justify-center">
				<v-btn size="large" @click="onCancel">
					{{ confirm.cancelText ? confirm.cancelText : cancelText }}
				</v-btn>
				<v-btn size="large" color="primary" @click="onConfirm">
					{{ confirm.confirmText ? confirm.confirmText : confirmText }}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	components: {},
	props: {
		value: {
			type: Boolean
		},
		confirm: {
			type: [Object, Promise],
			default: () => {
				return {}
			}
		}
	},
	data() {
		return {
			show: false,
			confirmText: this.$t('common.confirm'),
			cancelText: this.$t('common.cancel')
		}
	},
	computed: {},
	mounted() {},
	watch: {
		value(nv) {
			this.show = nv
		}
	},
	methods: {
		onConfirm() {
			this.$emit('confirm')
			if (this.confirm.confirmCallback) this.confirm.confirmCallback()
			if (this.confirm.resolve) {
				this.confirm.resolve(true)
			}
		},
		onCancel() {
			this.$emit('cancel')
			if (this.confirm.cancelCallback) this.confirm.cancelCallback()
			if (this.confirm.resolve) this.confirm.resolve(false)
		}
	}
}
</script>
